module.exports = angular.module('msi.toasts.container', []).name;

angular.module(module.exports)
  .component('ogToastContainer', require('./toast-container'))
  .value('injectToastContainerOnBody', true)
  .run(require('./init'));
